import * as React from 'react';
import { useTheme } from 'styled-components';
import { DSColour, getDSColour } from '../../../theme/DSColours';

export type DSCircleProps = {
    color: DSColour | string;
    size?: number;
};

export function DSCircle({ color, size = 28 }: DSCircleProps): JSX.Element {
    const theme = useTheme();
    const colorString = color in DSColour ? getDSColour(color as DSColour, theme) : color;
    const cPos = size / 2;
    const radius = size / 2;
    return (
        <svg height={size} width={size}>
            <circle cx={cPos} cy={cPos} fill={colorString} r={radius} />
        </svg>
    );
}
DSCircle.displayName = 'DSCircle';
DSCircle.colours = DSColour;
